export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9525_B_': 'B:',
    '_9526_S_B_': 'Tactic:',
    '_9561_ACTIVE_FOR_THIS_METRIC': 'Active for this Metric',
    '_9495_PRE_APPROVAL': 'Pre-Approval',
    '_9476_DRAFT': 'Draft',
    '_8702_UPDATING': 'Updating',
    '_7441_PENDING_CLOSE': 'Pending Close',
    '_9563_RECENTLY_CLOSED': 'Recently Closed',
    '_9564_OPPORTUNITY_TO_DEMONSTRATE_': 'Opportunity to Demonstrate:',
    '_9565_WILLINGNESS_TO_TRY_': 'Willingness to Try:',
    '_9566_PROFICIENCY_': 'Proficiency:',
    '_9567_OPPORTUNITY_TO_DEMONSTRATE': 'Opportunity to Demonstrate',
    '_9568_WILLINGNESS_TO_TRY': 'Willingness to Try',
    '_7317_PROFICIENCY': 'Proficiency',
    '_9427_GOAL_METRIC': 'Goal Metric',
    '_767___TO_GOAL': '% to Goal',
    '_9434_DAYS_TO_ACHIEVEMENT': 'Days to Achievement',
    '_9569_TODAY': 'Today',
    '_9570_DAYS': 'days',
    '_842_N_A': 'N/A',
    '_9572_PUBLISHED_FOR_THIS_METRIC': 'Published for this metric',
    '_9573_DRAFT_FOR_THIS_METRIC': 'Draft for this metric',
    '_9574_PUBLISHED_FOR_OTHER_METRICS_COMMITMENTS': 'Published for Other Metrics/Commitments',
    '_9575_DRAFT_FOR_OTHER_METRICS_COMMITMENTS': 'Draft for Other Metrics/Commitments',
    '_9576_DRAFT_UNFOCUSED': 'Draft UNFOCUSED',
    '_9577_NOTES_': 'Notes:',
    '_9578_INTERACTIONS_EVALUATED_': 'Interactions Evaluated:',
    '_9783_DATE_': 'Date:',
    '_9579_FOCUS_CONTAINER__UNFOCUSED_': 'Focus Container (Unfocused)',
    '_9479_CONFIRMATION': 'Confirmation',
    '_9580_DO_YOU_WANT_TO_EDIT_THIS_COMMITMENT_': 'Do you want to edit this commitment?',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9581_DO_YOU_WANT_TO_ADD_AN_OBSERVATION_TO_THIS_COMMITMENT_': 'Do you want to add an observation to this commitment?',
    '_9582_WORKING_ON_THIS_COMMITMENT': 'Working on this Commitment',
    '_9583_DO_YOU_WANT_TO_EDIT_THIS_OBSERVATION_': 'Do you want to edit this observation?',
    '_9584_COMMITMENT_DETAIL': 'Commitment Detail',
    '_9486_CREATOR_': 'Creator:',
    '_7310_SESSION_DATE': 'Session Date',
    '_9585_SESSION_DATE_': 'Session Date:',
    '_9487_COMMITMENT_NARRATIVE': 'Commitment Narrative',
    '_9586_I_WILL___': 'I will...',
    '_9587_I_WILL_KNOW_THAT_I_AM_SUCCESSFUL_WHEN___': 'I will know that I am successful when...',
    '_125_ACTIVE': 'Active',
    '_7440_CLOSED': 'Closed',
    '_7381_GOAL_DETAILS': 'Goal Details',
    '_9588_START': 'Start',
    '_9589_CURRENT': 'Current',
    '_713_METRIC': 'Metric',
    '_721_GOAL': 'Goal',
    '_7329_CREATED_ON': 'Created On',
    '_127_STATUS': 'Status',
    '_725_ACTUAL': 'Actual',
    '_768___TO_TARGET': '% to Target',
    '_9779_EXPECTED_ACHIEVEMENT_DATE': 'Expected Achievement Date',
    '_9590_DAYS_UNTIL_EXPIRY': 'Days Until Expiry',
    '_9473_DAYS_ACTIVE': 'Days Active',
    '_7379_OBSERVATION_DETAILS': 'Observation Details',
    '_7309_SESSION_TYPE': 'Session Type',
    '_7347_OBSERVER': 'Observer',
    '_9785_INTERACTIONS': 'Interactions',
    '_9784_NOTES': 'Notes',
    '_9591_EDIT_THIS_COMMITMENT': 'Edit this commitment',
    '_9592_ADD_AN_OBSERVATION': 'Add an Observation',
    '_9593_GO_TO_OBSERVATION': 'Go to Observation',
    '_7453_COMMITMENTS': 'Commitments',
    '_7377_OBSERVATIONS': 'Observations',
    '_9594_UPDATED': 'Updated',
    '_9595_NEW': 'New',
    '_9776_EDIT_COMMITMENT': 'Edit Commitment',
    '_9742_ADD_OBSERVATION': 'Add Observation',
    '_9743_EDIT_OBSERVATION': 'Edit Observation',
    '_9744_VIEW_OBSERVATION': 'View Observation',
    '_9552_SG_': 'SG:',
    '_9792_BEING_DISPUTED': 'Being Disputed',
    '_9791_PENDING_APPROVAL': 'Pending Approval',
    '_9819_REVIEWING_THIS_COMMITMENT': 'Reviewing this Commitment',
    '_8703_DISPUTED': 'Disputed',
    '_9793_DISPUTED_BY_ME': 'Disputed by Me',
    '_9113_PUBLISHED': 'Published',
    '_9820_DRAFT_UNFOCUSED': 'Draft Unfocused',
    '_9821_PUBLISHED_UNFOCUSED': 'Published Unfocused',
    '_9814_ACTIVE__WITH_A_DRAFT_VERSION_': 'Active (With a Draft Version)',
    '_9806_ACTIVE_FOR_OTHER_METRIC': 'Active for other Metric',
    '_9809_MISSED': 'Missed',
    '_9822_SELECTED_METRIC': 'Selected Metric',
    '_9816_DRAFT__WITH_AN_ACTIVE_VERSION_': 'Draft (With an Active Version)',
    '_9996_TRANSCRIPTS': 'Transcripts'
};
